import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import BlogPostBreadcrumbs from './components/BlogPostBreadcrumbs/BlogPostBreadcrumbs';
import Image from '../../atoms/Image';
import MarkdownContent from '../../components/MarkdownContent/MarkdownContent';
import { formatAuthor } from '../../services/blog';
import { ImagePropType } from '../../services/proptypes';
import DateUtils from '../../utils/date/DateUtils';
import './BlogPost.less';
var defaultProps = {
  publishedAt: '',
  heroImage: null,
  heroImageAltText: '',
  author: null,
  markdown: false,
  blogRootSlug: '/blog/'
};
export default function BlogPost(_ref) {
  var title = _ref.title,
    publishedAt = _ref.publishedAt,
    author = _ref.author,
    heroImage = _ref.heroImage,
    heroImageAltText = _ref.heroImageAltText,
    content = _ref.content,
    markdown = _ref.markdown,
    blogRootSlug = _ref.blogRootSlug;
  function getHeaderText() {
    var authorString = formatAuthor(author);
    var headerParts = !_isEmpty(publishedAt) ? [DateUtils.format(DateUtils.parseISO(publishedAt), 'PPP')] : [];
    if (!_isEmpty(authorString)) {
      headerParts = [authorString].concat(_toConsumableArray(headerParts));
    }
    return headerParts.join(' | ');
  }
  function getContent() {
    return markdown ? /*#__PURE__*/React.createElement(MarkdownContent, {
      className: "markdown",
      content: content
    }) : content;
  }
  var headerText = getHeaderText();
  return /*#__PURE__*/React.createElement("div", {
    className: "blog-post"
  }, /*#__PURE__*/React.createElement(BlogPostBreadcrumbs, {
    title: title,
    blogRootSlug: blogRootSlug
  }), /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, title), heroImage && /*#__PURE__*/React.createElement(Image, {
    className: "blog-post-image",
    src: heroImage,
    altText: heroImageAltText,
    loadStrategy: "eager"
  }), !_isEmpty(headerText) && /*#__PURE__*/React.createElement("header", {
    className: "author-and-date"
  }, headerText)), /*#__PURE__*/React.createElement("section", {
    className: "blog-post-content-section ".concat(markdown ? '' : 'white-space-line-break')
  }, getContent())));
}
BlogPost.defaultProps = defaultProps;